import { useEffect, useState } from 'react';

const DELAY = 50;

/**
 * This hook is used to delay the value of a boolean state. It sets the state to
 * true immediately when the value is true, and sets it to false after a
 * specified delay when the value is false.
 *
 * @param value - The boolean value to be delayed.
 * @returns The delayed boolean value.
 */
export const useDelayedFalse = (value: boolean): boolean => {
  const [delayedValue, setDelayedValue] = useState(value);

  useEffect(() => {
    if (value) {
      setDelayedValue(true);
      return;
    }

    const timeout = setTimeout(() => {
      setDelayedValue(false);
    }, DELAY);

    return () => {
      clearTimeout(timeout);
    };
  }, [value]);

  return delayedValue;
};
